import {InjectionToken} from '@angular/core';

export interface DataRequirements {
  saveData(keyword, value);
}

export const DataRequirementsInjectionToken = new InjectionToken<DataRequirements>('redirect Data Requirements')
